export default class SearchParamUtil {

 static TEXT  = "text";
 static ASSETID_FILTER_LIST  = "assetIdFilterList";
 static CATEGORY_ID = "categoryId";
}